module.exports = __webpack_public_path__ + "img/3d9fc49.png";